import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.667 4h2.666a.667.667 0 1 1 0 1.333h-.666v7.334a2 2 0 0 1-2 2H5.333a2 2 0 0 1-2-2V5.333h-.666a.667.667 0 0 1 0-1.333h2.666v-.667a2 2 0 0 1 2-2h1.334a2 2 0 0 1 2 2zM6.862 2.862a.67.67 0 0 0-.195.471V4h2.666v-.667a.667.667 0 0 0-.666-.666H7.333a.67.67 0 0 0-.471.195M6.667 12a.667.667 0 0 0 .666-.667v-4a.667.667 0 1 0-1.333 0v4a.667.667 0 0 0 .667.667m2.666 0a.667.667 0 0 0 .667-.667v-4a.667.667 0 0 0-1.333 0v4a.667.667 0 0 0 .666.667",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })